import { ComponentProps, MouseEvent } from 'react';
import { css } from '@emotion/react';

import { AdBanner, ProductCardAdBanner } from '@widgets/ad';
import {
  createVirtuosoGridContainer,
  UxGoodsCardItemForVerticalProductCard,
  VerticalProductCardWithItem,
  VerticalProductCardWithItemProps,
} from '@common/product-card';

import { convertToProductCardAdBannerIndex } from '../utils/convertToProductCardAdBannerIndex';
import { isProductCardAdBannerSlot } from '../utils/isProductCardAdBannerSlot';

interface ContainerOtherProps
  extends Pick<VerticalProductCardWithItemProps<UxGoodsCardItemForVerticalProductCard>, 'productNameLineClamp'> {
  product_card_ubl_handler?: {
    onImpression?: (item: UxGoodsCardItemForVerticalProductCard, index: number) => void;
    onClick?: (item: UxGoodsCardItemForVerticalProductCard, index: number, event: MouseEvent<HTMLElement>) => void;
    onLikeClick?: (isLiked: boolean, item: UxGoodsCardItemForVerticalProductCard, index: number) => void;
  };
  ad_banner_ubl_handler?: ComponentProps<typeof ProductCardAdBanner>['ubl_handler'];
  product_card_ad_banner_items: AdBanner[];
  ad_banner_items: AdBanner[];
  is_ad_banner_enabled: boolean;
}

export const VerticalProductCardWithAdBannerGridContainer = createVirtuosoGridContainer<
  ContainerOtherProps,
  UxGoodsCardItemForVerticalProductCard
>({
  renderProductCard: (item, item_index, context) => {
    const { columnStyle, otherProps, size } = context;
    const {
      productNameLineClamp,
      product_card_ubl_handler,
      ad_banner_ubl_handler,
      product_card_ad_banner_items,
      is_ad_banner_enabled,
    } = otherProps;

    const ad_banner = product_card_ad_banner_items[convertToProductCardAdBannerIndex({ index: item_index })];
    const is_ad_banner_slot = isProductCardAdBannerSlot({ index: item_index });

    if (is_ad_banner_slot && !!ad_banner && is_ad_banner_enabled) {
      return <ProductCardAdBanner css={styles.banner} item={ad_banner} ubl_handler={ad_banner_ubl_handler} />;
    }

    return (
      <VerticalProductCardWithItem
        size={size}
        productNameLineClamp={productNameLineClamp}
        metadataPadding={columnStyle === 'basic'}
        item={item}
        onImpression={(item) => product_card_ubl_handler?.onImpression?.(item, item_index)}
        onClick={(item, event) => product_card_ubl_handler?.onClick?.(item, item_index, event)}
        onLikeClick={(isLiked, item) => product_card_ubl_handler?.onLikeClick?.(isLiked, item, item_index)}
      />
    );
  },
});

const styles = {
  banner: css`
    margin-bottom: -22px;
  `,
};
